const locales = require('./locales').locales;
const trim = require('lodash/trim');

module.exports.sanitizeNumber = (requestLocale, value) => {
  const locale = locales[requestLocale];

  if (locale && value) {
    //Escape any dots in the separators so it works in the value.replace() statements
    const orderSeparatorRegexp = new RegExp(locale.orderSeparator.replace(/([\.])/g, '\\$1'), 'g');
    const decimalSeparatorRegexp = new RegExp(locale.decimalSeparator.replace(/([\.])/g, '\\$1'), 'g');
    value = trim(value).replace(orderSeparatorRegexp, '');
    value = trim(value).replace(decimalSeparatorRegexp, '.');
    value = parseFloat(value);
  }

  return value;
};
